import { RegionType } from '@wix/shoutout-email-model-v3';
import { get } from 'lodash';
import { getValueOrFallback } from '../../utils/get-value-or-fallback';
import { getMessageWidth } from '../../utils/get-message-width';
import { defaultTextPadding } from '../../utils/defaults';
import * as cssUtils from '../../utils/css-utils';
import { getPxValue } from '../../utils/line-height-to-px';
import { getColumnOfRegion, calculateColumnDesktopDisplayWidth, balanceGapsBetweenColumns, } from './utils';
import { getImage } from './get-image';
import { getText } from './get-text';
import { getButton } from './get-button';
export var getMixSection = function (_a) {
    var composerData = _a.composerData, css = _a.css, experiments = _a.experiments, isRtl = _a.isRtl, region = _a.region, manipulateHtml = _a.manipulateHtml, replaceImagePlaceholders = _a.replaceImagePlaceholders;
    if (region.type !== RegionType.Mix) {
        throw Error('Mix must be passed');
    }
    var userSpacingsOverrides = get(region, 'data.styles.spacings');
    var spacerHeight = (userSpacingsOverrides === null || userSpacingsOverrides === void 0 ? void 0 : userSpacingsOverrides.horizontalSpacing) ||
        getValueOrFallback(composerData, 'styles.css.so-global-region-mix-separator.marginBottom', '32px');
    var messageContentWidth = getMessageWidth(composerData, css);
    var numberOfColumns = region.data.layout.rows[0].columns.length;
    var verticalSpacing = (userSpacingsOverrides === null || userSpacingsOverrides === void 0 ? void 0 : userSpacingsOverrides.verticalSpacing)
        ? parseInt(userSpacingsOverrides === null || userSpacingsOverrides === void 0 ? void 0 : userSpacingsOverrides.verticalSpacing, 10)
        : null;
    var balancedColumnPaddings = balanceGapsBetweenColumns(parseInt(verticalSpacing === null
        ? getValueOrFallback(css, 'so-global-region-mix-left.paddingRight', defaultTextPadding)
        : Math.floor(verticalSpacing / 2.0), 10), parseInt(verticalSpacing === null
        ? getValueOrFallback(css, 'so-global-region-mix-right.paddingLeft', defaultTextPadding)
        : Math.ceil(verticalSpacing / 2.0), 10), numberOfColumns);
    var leftColumnPadding = balancedColumnPaddings.right;
    var rightColumnPadding = balancedColumnPaddings.left;
    var userOverrides = get(region, 'data.styles.region');
    var rules = [
        userOverrides,
        css['so-global-region-mix'],
        css['so-global-region'],
    ];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
    var outerPadding = cssUtils.margin(rules);
    var innerPadding = cssUtils.padding(rules);
    var columnsWidths = calculateColumnDesktopDisplayWidth({
        columns: region.data.layout.rows[0].columns,
        messageContentWidth: messageContentWidth,
        outerPadding: outerPadding,
        innerPadding: innerPadding,
        leftColumnPadding: leftColumnPadding,
        rightColumnPadding: rightColumnPadding,
        isRtl: isRtl,
    });
    var regions = region.data.regions.map(function (regionDefinition) {
        var _a;
        if (regionDefinition.type === 'text') {
            return getText({
                region: regionDefinition,
                css: css,
                composerData: composerData,
                experiments: experiments,
                isRtl: isRtl,
                manipulateHtml: manipulateHtml,
            });
        }
        if (regionDefinition.type === 'image') {
            var colWidth = (_a = region.data.layout.rows[0].columns.find(function (col) {
                return col.regionIds.includes(regionDefinition.regionId);
            })) === null || _a === void 0 ? void 0 : _a.width;
            if (colWidth === 0) {
                colWidth = 50;
            }
            return getImage({
                region: regionDefinition,
                composerData: composerData,
                getColumnOfRegion: getColumnOfRegion(region, regionDefinition),
                numberOfColumns: numberOfColumns,
                columnWidth: colWidth,
                balancedColumnPaddings: balancedColumnPaddings,
                userOverrides: userOverrides,
                replaceImagePlaceholders: replaceImagePlaceholders,
            });
        }
        if (regionDefinition.type === 'button') {
            return getButton({
                region: regionDefinition,
                css: css,
                isRtl: isRtl,
                experiments: experiments,
                mixData: region,
            });
        }
        return null;
    });
    return {
        widthsForMediaQueries: columnsWidths.map(function (column) { return column.displayWidth; }),
        regions: regions,
        columnsWidths: columnsWidths,
        layout: region.data.layout,
        noWrap: region.data.noWrap,
        leftColumnPadding: getPxValue(leftColumnPadding),
        rightColumnPadding: getPxValue(rightColumnPadding),
        spacerHeight: getPxValue(spacerHeight),
        outerPadding: outerPadding,
        innerPadding: innerPadding,
        cssClass: mobileCssClass,
    };
};
//# sourceMappingURL=get-mix-section.js.map